var map = {
	"./icon-announcement.svg": "d30c",
	"./icon-archive.svg": "1aeb",
	"./icon-arrow-down.svg": "c0ea",
	"./icon-arrow-left.svg": "88af",
	"./icon-arrow-right.svg": "22d6",
	"./icon-arrow-up.svg": "1787",
	"./icon-at-symbol.svg": "412d",
	"./icon-book.svg": "0f86",
	"./icon-bookmark.svg": "6997",
	"./icon-briefcase.svg": "388b",
	"./icon-browser.svg": "1fcb",
	"./icon-building.svg": "29e4",
	"./icon-calander.svg": "7b78",
	"./icon-call-incoming.svg": "f3fb",
	"./icon-call-outgoing.svg": "7bd8",
	"./icon-call.svg": "2f92",
	"./icon-camera.svg": "0f6f",
	"./icon-cart.svg": "e927",
	"./icon-chat.svg": "b3f3",
	"./icon-check-circle.svg": "2cf2",
	"./icon-cheveron-down.svg": "1278",
	"./icon-cheveron-left.svg": "869e",
	"./icon-cheveron-right.svg": "208e",
	"./icon-cheveron-up.svg": "388e",
	"./icon-clip.svg": "44f6",
	"./icon-clipboard.svg": "a918",
	"./icon-clock.svg": "afd7",
	"./icon-code.svg": "8f78",
	"./icon-cog.svg": "3bcd",
	"./icon-comment.svg": "a630",
	"./icon-compass.svg": "374a",
	"./icon-currency-dollar.svg": "3b1b",
	"./icon-dashboard.svg": "a91a",
	"./icon-desktop.svg": "454e",
	"./icon-discount.svg": "d241",
	"./icon-download.svg": "1cb8",
	"./icon-duplicate.svg": "fe91",
	"./icon-edit.svg": "bb74",
	"./icon-emotion-happy.svg": "8f7c",
	"./icon-emotion-sad.svg": "9cc8",
	"./icon-exclamation.svg": "4407",
	"./icon-external-link.svg": "04cf",
	"./icon-file-blank.svg": "8735",
	"./icon-file-minus.svg": "9bfa",
	"./icon-file-plus.svg": "e6a0",
	"./icon-file.svg": "d1e2",
	"./icon-film.svg": "ead2",
	"./icon-filter.svg": "27c9",
	"./icon-flag.svg": "0ffd",
	"./icon-folder-minus.svg": "1a6c",
	"./icon-folder-plus.svg": "8696",
	"./icon-folder.svg": "1a81",
	"./icon-globe.svg": "17ad",
	"./icon-graph-bar.svg": "34e1",
	"./icon-grid.svg": "c3ad",
	"./icon-group.svg": "43be",
	"./icon-hashtag.svg": "d2f1",
	"./icon-heart.svg": "13a3",
	"./icon-help.svg": "5f5a",
	"./icon-home.svg": "e94d",
	"./icon-image.svg": "76d1",
	"./icon-inbox.svg": "1821",
	"./icon-information.svg": "720f",
	"./icon-key.svg": "362b",
	"./icon-link.svg": "b6d8",
	"./icon-location.svg": "3c68",
	"./icon-lock-closed.svg": "2395",
	"./icon-lock-open.svg": "32cc",
	"./icon-mail.svg": "bf4b",
	"./icon-map.svg": "9178",
	"./icon-menu.svg": "237d",
	"./icon-microphone.svg": "6cbc",
	"./icon-minus-circle.svg": "f6a1",
	"./icon-minus-square.svg": "7224",
	"./icon-minus.svg": "2402",
	"./icon-mobile.svg": "eaf0",
	"./icon-moon.svg": "6eba",
	"./icon-more-horiz.svg": "dd4e",
	"./icon-music.svg": "9688",
	"./icon-news.svg": "a929",
	"./icon-notification.svg": "fec8",
	"./icon-plus-circle.svg": "b9ef",
	"./icon-plus-square.svg": "ccc7",
	"./icon-plus.svg": "410d",
	"./icon-print.svg": "b0d9",
	"./icon-puzzle.svg": "4a0c",
	"./icon-refresh.svg": "9d16",
	"./icon-repeat.svg": "394c",
	"./icon-rocket.svg": "3071",
	"./icon-search.svg": "9143",
	"./icon-server.svg": "b36a",
	"./icon-speaker.svg": "93e6",
	"./icon-star.svg": "0f78",
	"./icon-store.svg": "f06e",
	"./icon-tablet.svg": "9423",
	"./icon-tag.svg": "ec33",
	"./icon-thumb-down.svg": "4c62",
	"./icon-thumb-up.svg": "ae1c",
	"./icon-trash.svg": "8d4d",
	"./icon-trending-down.svg": "e3ff",
	"./icon-trending-up.svg": "e975",
	"./icon-trophy.svg": "ae44",
	"./icon-upload.svg": "ec0f",
	"./icon-user-check.svg": "a2fc",
	"./icon-user-minus.svg": "df16",
	"./icon-user-plus.svg": "ca06",
	"./icon-user.svg": "a305",
	"./icon-video.svg": "219d",
	"./icon-view.svg": "65cd",
	"./icon-x-circle.svg": "ba20",
	"./icon-x-square.svg": "3bf7",
	"./icon-x.svg": "f57f",
	"./icon-zoom-in.svg": "7d30",
	"./icon-zoom-out.svg": "cc49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd59";